import DeleteIcon from "@mui/icons-material/DeleteForever";
import { HistoryEntryIcon, HistoryEntryMainText, HistoryItemProps, UserInfoDisplay } from "./common";

export const HistoryItemDeleted = ({
  item,
  statusesConfig,
}: HistoryItemProps) => {
  return (
    <>
      <HistoryEntryIcon>
        <DeleteIcon sx={{ height: 20, color: "#F44336" }} />
      </HistoryEntryIcon>

      <HistoryEntryMainText>Deleted</HistoryEntryMainText>

      <UserInfoDisplay item={item} statusesConfig={statusesConfig} />
    </>
  );
};
